import { render, staticRenderFns } from "./FilePreviewCard.vue?vue&type=template&id=8c4d4912&scoped=true&"
import script from "./FilePreviewCard.vue?vue&type=script&lang=js&"
export * from "./FilePreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./FilePreviewCard.vue?vue&type=style&index=0&id=8c4d4912&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4d4912",
  null
  
)

export default component.exports